import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import { getTransactionDocRelatedRecords } from "../api/transaction-type";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Tabs,
  Tab,
} from "@mui/material";
import { invoicePayment } from "../config/grid-column-defs";
import { useSelector } from "react-redux";
import useSnackbar from "../hooks/useSnackbar";
import AgGridNonPaginatedTable from "./AgGridNonPaginatedTable";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      variant="h2"
      sx={{ m: 0, p: 1 }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function BillsPrintViewDialog({ open, id, handleClose, rowData }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [TableData, setTableData] = useState([]);
 const [loading, setLoading] = useState(false);

  async function getTransactionRelatedRecordsData(limit = 10, offset = 0) {
    setLoading(true);
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: id,
        limit,
        offset,
      });
      setTableData(data?.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  console.log(id, "id");
  return (
    <div className="dialogWidth">
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="dialog-box"
      >
        <Box className="viewDetilsBox" sx={{ Margin: 2, alignItems: "right" }}>
          <Button title="Print" onClick={() => window.print()}>
            <PrintIcon style={{ marginRight: "40px", marginTop: "-10px" }} />
          </Button>
        </Box>
        <DialogContent dividers id="dialog-content">
          <BootstrapDialogTitle sx={{ textAlign: "center" }}>
            <strong>Payments: Bill {rowData[0]?.vendor_invoice_number}</strong>
          </BootstrapDialogTitle>
          
          <Box className="viewDetilsBox">
            <>
              <AgGridNonPaginatedTable
                getTableRows={getTransactionRelatedRecordsData}
                columns={invoicePayment}
                refreshCounter={0}
                perPage={5}
              />
              <div className="m-b-10" style={{ border: "1px solid" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3} md={3} className="m-b-10">
                    <p className="tFormlabel" style={{ textAlign: "end" }}>
                      Total
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={5} md={5} className="m-b-10">
                    <p className="tFormName" style={{ textAlign: "end" }}>
                      {TableData?.totalsum}
                    </p>
                  </Grid>
                </Grid>
              </div>
            </>
          </Box>

          {/* body content */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
            className="backBtn"
          >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
